<template>

    <div class="flex flex-col lg:flex-row items-center justify-center lg:space-x-4 space-y-4 lg:space-y-0 h-full">
      <!-- column about me -->
      <div class="order-1 md:order-1 relative w-[374px] lg:h-[1010px] h-[200px]">

        <!-- overlay text -->
        <div class="absolute inset-0 flex items-center justify-center">
          <a href="/o-mne" title="O mně." class="text-center text-4xl hover:underline">
            O MNĚ
          </a>
        </div>
        <!-- /overlay text -->

        <!-- background image -->
        <img src="./../assets/images/omne.png" alt="odkaz bio" class="w-full h-full object-cover object-center" />
        <!-- /background image -->
      </div>
      <!-- /column about me -->

      <!-- column main -->
      <div class="order-3 md:order-2 relative w-[374px] lg:min-w-[374px] lg:w-[1010px] h-[1010px]">
        <!-- logo -->
        <div class="absolute top-[175px] left-1/2 transform -translate-x-1/2 w-full max-w-[95%] lg:max-w-[550px]">
          <img src="./../assets/images/logoMain.svg" alt="Overlay SVG" class="w-full h-auto max-w-full max-h-full" />
        </div>
        <!-- /logo -->

        <!-- background image -->
        <img src="./../assets/images/hlavni.png" alt="hlavni sekce" class="w-full h-full object-cover object-center" />
        <!-- /background image -->

      </div>
      <!-- /column main -->

      <!-- column shop -->
      <div class="order-2 md:order-3 relative w-[374px] lg:h-[1010px] h-[200px]">

        <!-- overlay text -->
        <div class="absolute inset-0 flex items-center justify-center">
          <a href="/katalog" title="Obchod." class="text-center text-4xl hover:underline">
            OBCHOD
          </a>
        </div>
        <!-- /overlay text -->

        <!-- background image -->
        <img src="./../assets/images/obchod.png" alt="odkaz obchod" class="w-full h-full object-cover object-center" />
        <!-- /background image -->
      </div>
      <!-- /column shop -->

    </div>

   </template>

<script>


export default {
  name: "Index",
  components: {},
  beforeCreate: function() {
    document.body.id = 'index';
  }
};
</script>
